import { sceneList } from '@/mocks/wuyi';
import SectionHeading from './SectionHeading';

export default function SceneSection() {
  return (
    <section id="scene" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="第一现场 · ON THE ROAD"
          title="假期"
          accent="见闻"
          desc="来自网友的第一视角分享——有人赶早、有人逛吃，每一个现场都藏着关于这个假期的小故事。"
        />

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {sceneList.map((s, idx) => (
            <article
              key={s.id}
              className={`group relative min-h-[300px] cursor-pointer overflow-hidden rounded-2xl md:min-h-[340px] ${
                idx % 2 === 1 ? 'md:translate-y-4' : ''
              }`}
            >
              <img
                src={s.image}
                alt={`${s.place} · ${s.title}`}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/20 to-transparent"></div>
              <div className="absolute inset-x-0 top-0 flex items-center justify-between p-5">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-primary-600">
                  <i className="ri-map-pin-2-line"></i>
                  {s.place}
                </span>
                <span className="rounded-full bg-background-950/40 px-3 py-1 text-xs text-background-50 backdrop-blur-sm">
                  见闻 · {String(idx + 1).padStart(2, '0')}
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                <h3 className="line-clamp-2 font-heading text-lg leading-snug text-background-50 md:text-xl">
                  {s.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-100/90">{s.blurb}</p>
                <p className="mt-3 flex items-center gap-2 text-xs text-background-100/70">
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-background-50/20">
                    <i className="ri-user-smile-line"></i>
                  </span>
                  @{s.author}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* 投稿引导 */}
        <div className="mt-14 flex flex-col items-center justify-between gap-5 rounded-2xl bg-accent-500 p-6 text-background-50 md:flex-row md:p-8">
          <div>
            <h3 className="font-heading text-xl md:text-2xl">在假期发现了有趣见闻或大瓜？</h3>
            <p className="mt-2 text-sm text-background-100/90">
              欢迎投稿分享你的一手现场，经核实后会整理补录进对应盘点栏目。
            </p>
          </div>
          <button
            type="button"
            onClick={() => document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap cursor-pointer inline-flex shrink-0 items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-accent-600 transition-colors hover:bg-background-100"
          >
            <i className="ri-edit-2-line"></i>
            联系小编投稿
          </button>
        </div>
      </div>
    </section>
  );
}